import { createApi, createBaseQuery } from '@adv-frontend/modules-query';
import {
    CollectMetricMethod,
    type CollectMetricPathParameters,
    type CollectMetricResponseSuccess,
    getCollectMetricUrl,
} from '@/shared/api/openApi';
import { request } from '@/shared/api/request';

const api = createApi({
    name: 'entities/trackEcomEvent/api/api',
    baseQuery: createBaseQuery(request),
    endpoints: (builder) => {
        return {
            Collect: builder.query<CollectMetricResponseSuccess, CollectMetricPathParameters & { query: string }>({
                query: ({ query, store_slug }) => {
                    return {
                        method: CollectMetricMethod,
                        url: `${getCollectMetricUrl({ store_slug })}?${query}`,
                    };
                },
            }),
        };
    },
});

export const collect = api.endpoints.Collect.query;
